import privacyImage from 'assets/privacy.svg';
import leaveWarningImage from 'assets/leave-or-exit-warning.svg';
import signoutIcon from 'assets/signout_info.svg';
import { HighmarkCommonAssets } from './types/highmark-common.types';

export const HIGHMARK_COMMON_ASSETS_MAP: HighmarkCommonAssets = {
  HIGHMARK_PRIVACY_IMAGE: privacyImage,
  HIGHMARK_EXIT_WARNING_IMAGE: leaveWarningImage,
  SIGNOUT_ICON: signoutIcon,
};
